import axios from 'axios';

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
    (res) => res,
    (err) => {
      const status = err?.response?.status
      if (status === 401 || status === 403) {
        // opzionale: evita loop se sei già sulla login
        if (!window.location.pathname.startsWith('/auth')) {
          window.location.href = '/auth'
        }
      }
      return Promise.reject(err)
    }
  )

export default axios;